import React, { Component } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { Input, Modal, Row, Col, Checkbox } from 'components/ui';
import { MIN_LARGE_INPUT_LENGTH, EMAIL_EVENTS } from 'constants/common';
import { getError, required, arrayRequired, minLength } from 'services/forms';

const validators = {
  url: [required, minLength(MIN_LARGE_INPUT_LENGTH)],
  events: [arrayRequired],
};

class CreateWebhook extends Component {
  state = {
    url: '',
    events: [],
    api_key: '',
    api_key_header_name: '',
    errors: {},
  };

  updateStateOnChange = (name, value) => {
    this.setState(
      prevState => ({
        [name]: value,
        errors: { ...prevState.errors, [name]: '' },
      }),
      this.updateUpstream,
    );
  };

  handleEmailEventChange = emailEvent => {
    const { events } = this.state;
    let newEventValue = emailEvent.target.name;
    let indexOfValue = events.indexOf(newEventValue);
    if (indexOfValue >= 0) events.splice(indexOfValue, 1);
    else events.push(newEventValue);
    this.updateStateOnChange('events', events);
  };

  handleInputChange = event => {
    const { name, value } = event.target;
    this.updateStateOnChange(name, value);
  };

  validateValues = async () => {
    const errors = {};
    // eslint-disable-next-line no-unused-vars
    for (const key in validators) {
      if (Object.hasOwnProperty.call(validators, key)) {
        const validator = validators[key];
        const value = this.state[key];
        errors[key] = await getError(value, validator);
      }
    }
    const hasError = find(errors, v => !!v);
    if (hasError) this.setState({ errors });
    return !hasError;
  };

  handleCreateWebhook = async () => {
    const { onCreateWebhook, templateId } = this.props;
    const { events, url, api_key, api_key_header_name } = this.state;
    if (await this.validateValues()) {
      const webhooks = [];
      events.forEach(event => {
        const webhook = {
          template_id: templateId,
          event,
          url,
          api_key,
          api_key_header_name,
        };
        webhooks.push(webhook);
      });
      onCreateWebhook(webhooks);
      this.handleHide();
    }
  };

  handleHide = () => {
    this.props.onHide();
    this.reset();
  };

  reset = () => {
    this.setState({
      url: '',
      events: [],
      errors: {},
    });
  };

  render() {
    const { errors, url, api_key, api_key_header_name } = this.state;
    const { isVisible } = this.props;

    return (
      <Modal
        visible={isVisible}
        onCancel={this.handleHide}
        onOk={this.handleCreateWebhook}
      >
        <div className="create-api-key">
          <h1>Create new Webhook(/s)</h1>
          <br />
          <Row>
            <h5>Select Events</h5>
            {EMAIL_EVENTS.map(sendThrough => (
              <Col key={sendThrough}>
                <Checkbox
                  checked={!!this.state.events.includes(sendThrough)}
                  error={errors.event}
                  helperTxt={errors.event}
                  name={sendThrough}
                  onChange={this.handleEmailEventChange}
                >
                  {sendThrough}
                </Checkbox>
              </Col>
            ))}
          </Row>
          <br />
          {errors && errors.events === 'Required' && (
            <div className="warning-sub-container">
              <i className="material-icons">report_problem</i>
              <span className="warning-text">
                {'Select atleast one Event!'}
              </span>
            </div>
          )}
          <br />
          <Input
            error={errors.url}
            helperTxt={errors.url}
            label=" URL"
            name="url"
            placeholder="https://somedomain.com/sub-url"
            value={url}
            onChange={this.handleInputChange}
          />

          <Input
            error={errors.api_key}
            helperTxt={errors.api_key}
            label=" API Key"
            name="api_key"
            placeholder="add api_key"
            value={api_key}
            onChange={this.handleInputChange}
          />

          {api_key && (
            <Input
              error={errors.api_key_header_name}
              helperTxt={errors.api_key_header_name}
              label=" API Key Header Name"
              name="api_key_header_name"
              placeholder="'api-key' will be used if not supplied"
              value={api_key_header_name}
              onChange={this.handleInputChange}
            />
          )}
        </div>
      </Modal>
    );
  }
}

CreateWebhook.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  templateId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onCreateWebhook: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
};

export default CreateWebhook;
